
import * as React from 'react';
import { Outlet } from 'react-router-dom';


export default function Layout3( ) {

    return (
        <>
            
            <div className="container  vh-100 d-flex align-items-center justify-content-center">
                <div className='w-100'>
                    <div className="row align-items-center  ">
                        <div className="col-md-10 mx-auto col-lg-5 " id="colMain2"> 
                            
                            <Outlet />

                        </div>
                    </div>
                </div>
            </div>
             


        </>
    );

}